<template>
    <modal @close="recurringChargeCancelClick" class="edit-modal" hideFooter id="recurring-charge">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Set Recurring Charge</h3>
                    <div class="mt-3">
                        <p>A recurring charge allows you to automatically "top-up" your promotion on a regular schedule of your choosing.</p>
                        <p>Setting a recurring charge will top-up your promotion immediately to the balance of your choosing and then will automatically top it up based on your selected frequency.  Any new recurring charge setting will override previous settings.</p>
                        <p>TruckDown will automatically email you a receipt each time your recurring charge is processed.</p>
                    </div>
                </div>
            </div>
            <div class="edit-pages">
                <div>
                    <div v-if="displayAddCreditCard == false">
                        <div>
                            <label class="td-checkbox-label td-text-bold">
                                Disable Recurring Charge
                                <input name="disableRecurringCharge" type="checkbox" v-model="disableRecurringCharge" />
                                <span></span>
                            </label>
                        </div>

                        <div v-if="!disableRecurringCharge" class="md-col-2 mt-5">
                            <div>
                                <div>
                                    <label class="td-label td-text-bold">Increase Balance To:</label>
                                    <input v-model="balance" type="number" @change="validate" :class="[{'error': displayError['balance']}]" placeholder="" />
                                    <error v-if="displayError['balance']" :error="errors['balance']"></error>
                                </div>

                                <div v-if="taxrate > 0">
                                    <p>Note: {{ taxname }} {{ taxrate.toFixed() }}% tax will be applied to each charge.</p>
                                </div>

                                <div class="mt-3 mb-2">
                                    <label class="td-label td-text-bold">Frequency (How Often):</label>
                                    <select id="recurringChangePeriod" @change="validate" class="td-select" v-model="frequency">
                                        <option :value="PromotionBillingPeriod.Monthly">Monthly</option>
                                        <option :value="PromotionBillingPeriod.Quarterly">Quarterly</option>
                                        <option :value="PromotionBillingPeriod.SemiAnnually">SemiAnnually</option>
                                        <option :value="PromotionBillingPeriod.Annually">Annually</option>
                                    </select>
                                </div>
                            </div>
                            <div>
                                <label class="td-label td-text-bold">Credit Card:</label>
                                <div v-if="selectedCreditCard != null">
                                    <span>
                                        {{ selectedCreditCard.numberDisplay }}
                                        <template v-if="selectedCreditCard.isPrimary">
                                            (Primary)
                                        </template>
                                    </span>
                                    <error v-if="displayError['selectedCreditCard']" :error="errors['selectedCreditCard']"></error>
                                </div>
                                <div v-if="selectedCreditCard == null">
                                    <a @click="displayAddCreditCard = true">Add Credit Card</a>
                                </div>
                                <div class="td-banner info mt-2">
                                    <p>Recurring charges will use the primary card on your account.</p>
                                </div>
                                <div v-if="selectedCreditCard" class="code mt-3 mb-2">
                                    <label class="td-label td-text-bold">Security Code:</label>
                                    <input v-model="securityCode" @change="validate" :class="[{'error': displayError['securityCode']}]" type="text" placeholder="e.g. 123" />
                                    <error v-if="displayError['securityCode']" :error="errors['securityCode']"></error>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="displayAddCreditCard == true" class="mb-5">
                        <h3>Add Credit Card</h3>
                        <add-credit-card :accountid="promotion.accountId" @save="addCreditCardSave" @cancel="addCreditCardCancel"></add-credit-card>
                    </div>

                </div>
                <div class="actions">
                    <div>
                        <button v-if="displayAddCreditCard == false" class="td-btn primary-outlined" @click="recurringChargeCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button v-if="displayAddCreditCard == false" class="td-btn btn secondary" @click="recurringChargeSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './RecurringCharge';
    export default script;
</script>
<style lang="less">
    @import './RecurringCharge.less';
</style>